module.exports = __webpack_public_path__ + "img/bonesandbodies.05f10b8a.png";